import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//Store modules

import DeprecatedApplicationStore from "./modules/deprecated-application/store";
import AccountStore from "./modules/main/store/account/account-store";
import DashboardStore from "./modules/dashboard/store/dashboard-store";
import DocumentStore from "./modules/documents/store/document-store";
import GuestUploadStore from "./modules/guest-upload/store/guest-upload-store";
import RouterStore from "./routes/store";
import WidgetStore from "./modules/widgets/store/widget-store";
import SupportStore from "./modules/support/store/support-store";
import MarketingUnsubscribeStore from "./modules/marketing-unsubscribe/store/marketing-unsubscribe-store";
import NoaPortalStore from "./modules/noa-portal/store/noa-portal-store";
import ApplicationStandaloneStore from "./modules/application-standalone/store/application-standalone-store";
import StatusPageStore from "./modules/status-page/store/status-page-store";
import GuestFillOutStore from "./modules/guest-fill-out/store/guest-fill-out-store";
import WebsocketStore from "./modules/websocket/store/websocket-store";
import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import createMutationsSharer from "vuex-shared-mutations";
import Amplitude from "@Shared/@Utils/amplitude";
import { cloneDeep, forOwn, pickBy } from "lodash";
Vue.use(Vuex);
Vue.config.devtools = process.env.ENVIRONMENT === "test";
const vuexPersist = new VuexPersist({
  strictMode: process.env.ENVIRONMENT === "test",
  key: "client-portal",
  storage: localStorage,
  modules: ["AccountStore"]
});
const modules = {
  RouterStore,
  DeprecatedApplicationStore,
  AccountStore,
  DashboardStore,
  DocumentStore,
  WidgetStore,
  SupportStore,
  MarketingUnsubscribeStore,
  GuestUploadStore,
  NoaPortalStore,
  ApplicationStandaloneStore,
  StatusPageStore,
  GuestFillOutStore,
  WebsocketStore
};
Vue.store = new Vuex.Store({
  strict: process.env.ENVIRONMENT === "test",
  state: {},
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
    resetState(state) {
      forOwn({
        AccountStore
      }, (value, key) => {
        state[key] = cloneDeep(value.state);
      });
    },
    clearState(state) {
      const storesExcludedFromClear = ["RouterStore"];
      const stores = pickBy(modules, (value, key) => !_includesInstanceProperty(storesExcludedFromClear).call(storesExcludedFromClear, key));
      forOwn(stores, (value, key) => {
        state[key] = cloneDeep(value.state);
      });
    }
  },
  actions: {},
  modules,
  plugins: [vuexPersist.plugin, createMutationsSharer({
    predicate: ["resetState", "clearState", "AccountStore/SET_SESSION_DETAILS", "AccountStore/SET_EMAIL_VERIFIED"]
  })]
});
Vue.store.subscribeAction({
  error: (action, state, error) => {
    Amplitude.logVuexActionError(error, action);
  }
});
export default Vue.store;